import { InitialConfiguration } from '../../../../shared/types/chat-assistant';

export const jsonAssistantDataToString = (
    values: InitialConfiguration | string
) => {
    if (typeof values === 'string') {
        return values;
    }

    if (!values || typeof values !== 'object') {
        return '';
    }

    return [
        {
            title: '1. Identidad y Rol',
            items: values.identityAndRole?.map(
                ({ title, description }) => `${title}: ${description}`
            ),
        },
        {
            title: '2. Objetivo y Estrategia de Respuesta',
            items: values.objectiveAndResponseStrategy?.map(
                ({ title, description }) => `${title}: ${description}`
            ),
        },
        {
            title: '3. Arquitectura de Comunicación (UX Conversacional)',
            items: values.communicationArchitecture?.map(
                ({ title, description }) => `${title}: ${description}`
            ),
        },
        {
            title: '4. Áreas de Dominio',
            items: values.domainAreas?.map(
                ({ title, description }) => `${title}: ${description}`
            ),
        },
        {
            title: '5. Estilo y Tonalidad',
            items: values.styleAndTonality?.map(
                ({ title, description }) => `${title}: ${description}`
            ),
        },
        {
            title: '6. Formato de Respuesta Inteligente',
            items: values.smartResponseFormat?.map(({ value }) => value),
        },
        {
            title: '7. Reglas de Uso de la Biblioteca de Conocimiento',
            items: values.knowledgeBaseRules?.map(({ value }) => value),
        },
        {
            title: '8. Protocolos de Escalamiento y Manejo de Casos',
            items: values.escalationAndCaseHandling?.map(({ value }) => value),
        },
        {
            title: '9. Memoria Conversacional Dinámica',
            items: values.dynamicConversationMemory?.map(({ value }) => value),
        },
        {
            title: '10. Resumen Estratégico',
            items: values.strategicSummary?.map(({ value }) => value),
        },
    ]
        .filter(({ items }) => items && items.length > 0)
        .map(({ title, items }) => `${title}\n${items?.join('\n')}\n`)
        .join('\n');
};
